import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "love-it-number-picker",
    templateUrl: "./number-picker.component.html",
    styleUrls: ["./number-picker.component.scss"],
    standalone: false
})
export class NumberPickerComponent implements OnInit {
  @Input() numberFormControl: FormControl;
  @Input() manualEnter = true;
  @Input() min: number;

  constructor() {}

  ngOnInit(): void {}

  changeAmount(changeBy: number) {
    const newAmount = (this.numberFormControl.value ?? 0) + changeBy;
    if (this.min !== null && newAmount < this.min) {
      return;
    }
    this.numberFormControl.setValue(newAmount);
    this.numberFormControl.markAsDirty();
  }
}
